var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('transition', {
    attrs: {
      "name": "slide-left",
      "mode": "out-in"
    }
  }, [_c(_vm.currentSlide, {
    directives: [{
      name: "hammer",
      rawName: "v-hammer:swipe",
      value: _vm.onSwipe,
      expression: "onSwipe",
      arg: "swipe"
    }],
    tag: "component"
  })], 1), _vm.isShownIndicators ? _c('div', {
    staticClass: "slider-indicators-container"
  }, _vm._l(_vm.slideList, function (slide, idx) {
    return _c('div', {
      key: idx,
      staticClass: "slider-indicator",
      class: {
        active: _vm.currentIndex === idx
      }
    });
  }), 0) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }